export enum TRANSPORT_ITEM_ESTIMATE_STEP {
  SETTING = 'SETTING',
  ITEM = 'ITEM',
  SPECIAL = 'SPECIAL',
}
